import type * as layout from '@ocodelib/compose-layout';
import { PLUGIN_KEYS } from '@ocodelib/vm-beluga-app';
import dynamic from 'next/dynamic';
import { config } from '../../config';
import { WorkspaceTopbar } from './WorkspaceTopbar';

const AppRootUi = dynamic(() => import('@ocodelib/vm-beluga-app').then((m) => m.AppRootUi));

export function BelugaAppLoader() {
  return (
    <AppRootUi
      onLayoutBuild={overrideLayout}
      appConfig={{
        datiBaseURL: config.datiBaseURL,
        apiBaseURL: config.apiBaseURL,
      }}
    />
  );
}

function overrideLayout(layoutManager: layout.ComposeLayoutManager) {
  function reg(key: string, component: React.ReactElement) {
    return layoutManager.registerPlugin(key, component);
  }
  reg(PLUGIN_KEYS.root.topBar, <WorkspaceTopbar />);
}
